import { Tooltip } from '@pypestream/design-system';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { TableCellCheckbox } from './editable-table-cell-checkbox';

import { NodeColumns, tableStore } from '../../stores/table-store';

interface NodeAnswerRequiredCheckboxProps {
  rowId: string;
  testId?: string;
}

export const NodeAnswerRequiredCheckbox: React.FC<NodeAnswerRequiredCheckboxProps> =
  observer(({ rowId, testId }) => {
    const shouldDisable = tableStore.isCellDisabled(
      rowId,
      NodeColumns.answerRequired
    );
    return shouldDisable ? (
      <Tooltip
        content="Answer is required when using an asset type or when saving user inputs to a variable."
        reusePortal
        tooltipId="answerRequired-tooltip"
      >
        <div style={{ display: 'flex', position: 'relative' }}>
          <TableCellCheckbox
            test-id={testId}
            rowId={rowId}
            columnId={NodeColumns.answerRequired}
            disabled={shouldDisable}
          />
        </div>
      </Tooltip>
    ) : (
      <TableCellCheckbox
        test-id={testId}
        rowId={rowId}
        columnId={NodeColumns.answerRequired}
        disabled={shouldDisable}
      />
    );
  });
